var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChiefActionOfficer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "61px",
    viewBox: "0 0 60 61",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Chief Action Officer")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chief-Action-Officer",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 19,
    y: 16,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 27,
    y: 13,
    width: 4,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 35,
    y: 10,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,30 C12,28.343 10.657,27 9,27 C7.343,27 6,28.343 6,30 L12,34 C12,35.657 10.657,37 9,37 C7.343,37 6,35.657 6,34",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29,
    cy: 35,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,41 L32.592,41 C31.541,41.631 30.315,42 29,42 C27.685,42 26.459,41.631 25.408,41 L23,41 C19.686,41 17,43.686 17,47 L17,59 L41,59 L41,47 C41,43.686 38.314,41 35,41 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.592,41 C31.541,41.631 30.315,42 29,42 C27.685,42 26.459,41.631 25.408,41 L25,41 L27,46 L26,52 L29,55 L32,52 L31,46 L33,41 L32.592,41 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,49 L38,49",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 32,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30 C52,28.343 50.657,27 49,27 C47.343,27 46,28.343 46,30 L52,34 C52,35.657 50.657,37 49,37 C47.343,37 46,35.657 46,34",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 49,
    cy: 32,
    r: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 14,
    y: 0,
    width: 30,
    height: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "19 13 24 8 28 9 33 4 37 6 41 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,53 L50,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,53 L54,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,50 L53,48",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,46 L53,44",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,53 L8,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,53 L4,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,50 L5,48",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,46 L5,44",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,20 L5,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,16 L5,14",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,12 L5,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,20 L53,18",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,16 L53,14",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,12 L53,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,11 L48,11",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,53 L46,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,53 L14,53",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11 L10,11",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,23 L9,41",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,23 L49,41",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChiefActionOfficer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chief-action-officer.5a8471f4.svg";
export { ForwardRef as ReactComponent };